const Condition = require( './Condition' );
const BattleCalc = require( '../BattleCalc' );

const SlowedCondition = function( instigator, owner, battleState, duration ) {
	const condition = new Condition( instigator, owner, battleState );
	condition.duration = duration;
	condition.handle = 'slowed';

	const extant = BattleCalc.getCondition( owner, 'slowed' );
	if( extant ) {
		battleState.expireCondition( extant.uid );
	}

	condition.initInterval( condition.expire, duration );
	if( battleState.paused ) {
		condition.intervalTimer.pause();
	}

	return condition;
};
module.exports = SlowedCondition
